import _ from 'lodash';
import { ORDER_TYPES, PRODUCT_TYPES, RUN_TYPES } from 'v2/common/constants/index';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const { isCrypto } = ApplicationDomainUtility;

export const onChangeOrderType = ({
  orderType,
  quantConfig,
  runType,
  isStrategyAuthor
}) => {
  const omitKeysForNotActual = [
    'entryOrderType', 'exitOrderType', 'product', 'entryOrderModification', 'exitOrderModification',
    'isPlaceOptionsEntryBuyOrdersFirst',
    'isPlaceStoplossOrderToBroker', 'isSquareOffTransactionIfEntryFailed',
    'stopAndLimitPriceDifferenceInPercentage'
  ];
  const isLive = runType === RUN_TYPES.live;
  const isActual = orderType !== ORDER_TYPES.paper.value && isLive;

  let sanitizedQuantConfig = _.cloneDeep(quantConfig);
  if (!isActual && !isStrategyAuthor) {
    sanitizedQuantConfig = _.omit(sanitizedQuantConfig, omitKeysForNotActual);
  }
  if (isActual || isStrategyAuthor) {
    const {
      product, entryOrderType, entryOrderModification,
      exitOrderType, exitOrderModification, limitOrderBufferPercentage,
      slOrderPlaceBasedOnPrice, isPlaceOptionsEntryBuyOrdersFirst,
      stopAndLimitPriceDifferenceInPercentage, isPlaceStoplossOrderToBroker,
      isSquareOffTransactionIfEntryFailed,
    } = quantConfig;

    if (!product) sanitizedQuantConfig.product = isCrypto ? PRODUCT_TYPES.normal.value : PRODUCT_TYPES.mis.value;
    if (!entryOrderType) sanitizedQuantConfig.entryOrderType = 'market';
    if (_.isEmpty(entryOrderModification)) sanitizedQuantConfig.entryOrderModification = {};
    if (!exitOrderType) sanitizedQuantConfig.exitOrderType = 'market';
    if (isPlaceOptionsEntryBuyOrdersFirst === undefined) {
      sanitizedQuantConfig.isPlaceOptionsEntryBuyOrdersFirst = isCrypto ? false : true;
    }
    if (isPlaceStoplossOrderToBroker === undefined) {
      sanitizedQuantConfig.isPlaceStoplossOrderToBroker = true;
    }
    if (!stopAndLimitPriceDifferenceInPercentage) {
      sanitizedQuantConfig.stopAndLimitPriceDifferenceInPercentage = 0;
    }
    if (_.isEmpty(exitOrderModification)) sanitizedQuantConfig.exitOrderModification = {};
    if (!limitOrderBufferPercentage) sanitizedQuantConfig.limitOrderBufferPercentage = 0;
    if (isSquareOffTransactionIfEntryFailed === undefined) {
      sanitizedQuantConfig.isSquareOffTransactionIfEntryFailed = false;
    }
    if (!slOrderPlaceBasedOnPrice) sanitizedQuantConfig.slOrderPlaceBasedOnPrice = 'traded_price';
  }

  return { orderType, quantConfig: sanitizedQuantConfig, runType };
};
